import React, { createContext, useContext, useReducer } from "react";
import { AuthProvider } from "./AuthProvider";

export const CreateAppContext = createContext();

const AppContext = ({ reducerApp, children, initialStateApp }) => (
  <CreateAppContext.Provider value={useReducer(reducerApp, initialStateApp)}>
    <AuthProvider>{children}</AuthProvider>
  </CreateAppContext.Provider>
);

export default AppContext;

export const UseContextApp = () => useContext(CreateAppContext);
